export const featuredProducts = [
  {
    id: 1,
    name: 'Charizard VSTAR - Rainbow Rare',
    category: 'Pokemon',
    set: 'Brilliant Stars',
    price: 149.99,
    originalPrice: 189.99,
    image: '🔥',
    rating: 5,
    reviews: 234,
    stock: 3,
    isNew: false,
    isTrending: true,
    discount: 20,
  },
  {
    id: 2,
    name: 'Black Lotus - Reprint',
    category: 'Magic',
    set: '30th Anniversary Edition',
    price: 999.99,
    image: '🌺',
    rating: 5,
    reviews: 89,
    stock: 1,
    isNew: false,
    isTrending: true,
  },
  {
    id: 3,
    name: 'Blue-Eyes White Dragon',
    category: 'Yu-Gi-Oh',
    set: 'Legend of Blue Eyes',
    price: 299.99,
    image: '🐉',
    rating: 4.8,
    reviews: 156,
    stock: 5,
    isNew: false,
  },
  {
    id: 4,
    name: 'Monkey D. Luffy - Leader',
    category: 'One Piece',
    set: 'Romance Dawn',
    price: 24.99,
    image: '⚓',
    rating: 4.5,
    reviews: 67,
    stock: 15,
    isNew: true,
  },
  {
    id: 5,
    name: 'Pikachu VMAX - Gold',
    category: 'Pokemon',
    set: 'Vivid Voltage',
    price: 399.99,
    originalPrice: 449.99,
    image: '⚡',
    rating: 5,
    reviews: 312,
    stock: 2,
    isTrending: true,
  },
  {
    id: 6,
    name: 'Sol Ring - Foil',
    category: 'Magic',
    set: 'Commander Masters',
    price: 34.99,
    image: '💍',
    rating: 4.7,
    reviews: 203,
    stock: 8,
  },
  {
    id: 7,
    name: 'Omnimon - Alt Art',
    category: 'Digimon',
    set: 'BT5 Battle of Omni',
    price: 89.99,
    image: '🦖',
    rating: 4.6,
    reviews: 45,
    stock: 6,
    isNew: true,
  },
  {
    id: 8,
    name: 'Dark Magician - Ghost Rare',
    category: 'Yu-Gi-Oh',
    set: 'Ghosts From the Past',
    price: 179.99,
    image: '🎩',
    rating: 4.9,
    reviews: 98,
    stock: 4,
  },
];

export const allProducts = [
  ...featuredProducts,
  {
    id: 9,
    name: 'Mew VMAX - Rainbow',
    category: 'Pokemon',
    set: 'Fusion Strike',
    price: 89.99,
    image: '🌟',
    rating: 4.4,
    reviews: 123,
    stock: 7,
  },
  {
    id: 10,
    name: 'Jace, the Mind Sculptor',
    category: 'Magic',
    set: 'Worldwake',
    price: 74.99,
    image: '🧠',
    rating: 4.8,
    reviews: 167,
    stock: 5,
  },
  {
    id: 11,
    name: 'Ash Blossom & Joyous Spring',
    category: 'Yu-Gi-Oh',
    set: 'Maximum Crisis',
    price: 44.99,
    image: '🌸',
    rating: 4.6,
    reviews: 89,
    stock: 12,
  },
  {
    id: 12,
    name: 'Roronoa Zoro - Leader',
    category: 'One Piece',
    set: 'Romance Dawn',
    price: 19.99,
    image: '⚔️',
    rating: 4.5,
    reviews: 56,
    stock: 20,
    isNew: true,
  },
  {
    id: 13,
    name: 'Ultra Pro Deck Box - Black',
    category: 'Accessories',
    price: 9.99,
    image: '📦',
    rating: 4.3,
    reviews: 234,
    stock: 50,
  },
  {
    id: 14,
    name: 'Dragon Shield Sleeves - Matte Black',
    category: 'Accessories',
    price: 12.99,
    image: '🛡️',
    rating: 4.7,
    reviews: 456,
    stock: 100,
  },
  {
    id: 15,
    name: 'Playmat - Galaxy Design',
    category: 'Accessories',
    price: 24.99,
    image: '🌌',
    rating: 4.5,
    reviews: 78,
    stock: 25,
  },
  {
    id: 16,
    name: '9-Pocket Binder - Premium',
    category: 'Accessories',
    price: 29.99,
    image: '📚',
    rating: 4.6,
    reviews: 189,
    stock: 30,
  },
];
